module.exports = __webpack_public_path__ + "static/media/ipo-platform-mockups.ae27e666.png";